module.exports = __webpack_public_path__ + "img/human-greeting.5906942b.svg";